// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "drive_account".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "drive_account" table (1:1 with a DB row, on the wire). */
export const driveAccountAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    email: z.string(),
    displayName: z.string().nullable(),
    profilePicture: z.string().nullable(),
    encryptedCredentials: z.string(),
    tokenExpiresAt: z.string().datetime().nullable(),
    isActive: z.boolean(),
    lastSyncAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=driveAccount.js.map